import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './search-results.component.scss';
var SearchResults = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResults, _super);
    function SearchResults(element) {
        return _super.call(this, element) || this;
    }
    SearchResults.prototype.init = function () { };
    SearchResults.prototype.bindEvents = function () { };
    return SearchResults;
}(Base));
export { SearchResults };



//////////////////
// WEBPACK FOOTER
// ./components/search-results/search-results.component.ts
// module id = 488
// module chunks = 0